
import ROUTERS from '../../commons/constans/router';
import React, { lazy } from 'react';

const AwardComponent = lazy(() => import('../../pages/Award/containers/AwardPageContainer'));
const AwardRegisterContainer = lazy(() => import('../../pages/Award/containers/AwardRegisterContainer'));
const AwardVoteContainer = lazy(() => import('../../pages/Award/containers/AwardVoteContainer'));

const route = [
  {
    path: ROUTERS.AWARD,
    title: 'Award',
    exact: true,
    public: false,
    component: <AwardComponent />
  },
  {
    path: ROUTERS.AWARD_REGISTER,
    title: 'Award register',
    exact: true,
    public: false,
    component: <AwardRegisterContainer />
  },
  {
    path: ROUTERS.AWARD_VOTING,
    title: 'Award Voting',
    exact: true,
    public: false,
    component: <AwardVoteContainer />
  },
  
];

export default route;
